// components/AddressForm.js
import React from "react";
import { Form, Col, Row } from "react-bootstrap";
import Autocomplete from "react-google-autocomplete";

const AddressForm = ({ address, setAddress, validated }) => {
  const handlePlaceSelect = (place) => {
    const components = {
      company_add1: "",
      company_add2: "",
      company_add3: "",
      company_add4: "",
      postcode: "",
      lat: "",
      lng: "",
    };

    if (!place.address_components) return;

    place.address_components.forEach((component) => {
      if (component.types.includes("street_number")) {
        components.company_add1 = component.long_name;
      }
      if (component.types.includes("route")) {
        components.company_add1 += ` ${component.long_name}`;
      }
      if (component.types.includes("sublocality_level_1")) {
        components.company_add2 = component.long_name;
      }
      if (component.types.includes("locality") || component.types.includes("postal_town")) {
        components.company_add3 = component.long_name;
      }
      if (component.types.includes("administrative_area_level_2")) {
        components.company_add4 = component.long_name;
      }
      if (component.types.includes("postal_code")) {
        components.postcode = component.long_name;
      }
    });

    if (place.geometry?.location) {
      components.lat = place.geometry.location.lat();
      components.lng = place.geometry.location.lng();
    }

    setAddress(components);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setAddress((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  return (
    <>
      <Row>
        <Col>
          <Autocomplete
            apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
            onPlaceSelected={handlePlaceSelect}
            className="form-control mb-3"
            placeholder="Start typing a postcode or address..."
            options={{
              types: ["geocode"],
              fields: ["address_components", "geometry","formatted_address"],
              componentRestrictions: { country: "gb" },
            }}
          />
        </Col>
      </Row>

    <Form.Label htmlFor="eventTitle">Address</Form.Label>

      <Form.Group className="mb-2" controlId="company_add1">
        {/* <Form.Label>Address Line 1</Form.Label> */}
        <Form.Control
          type="text"
          value={address.company_add1}
          onChange={handleChange}
          required
          isInvalid={validated && !address.company_add1}
          placeholder="Address Line 1" 
        />
        <Form.Control.Feedback type="invalid">
          Please enter address line 1.
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="mb-2" controlId="company_add2">
        {/* <Form.Label>Address Line 2</Form.Label> */}
        <Form.Control
          type="text"
          value={address.company_add2}
          onChange={handleChange}
          placeholder="Address Line 2" 
        />
      </Form.Group>

      <Form.Group className="mb-2" controlId="company_add3">
        {/* <Form.Label>Address Line 3</Form.Label> */}
        <Form.Control
          type="text"
          value={address.company_add3}
          onChange={handleChange}
          placeholder="Town/City" 
        />
      </Form.Group>

      <Form.Group className="mb-2" controlId="company_add4">
        {/* <Form.Label>Address Line 4</Form.Label> */}
        <Form.Control
          type="text"
          value={address.company_add4}
          onChange={handleChange}
          placeholder="County" 
        />
      </Form.Group>

      <Form.Group className="mb-2" controlId="postcode">
        {/* <Form.Label>Postcode</Form.Label> */}
        <Form.Control
          type="text"
          value={address.postcode}
          onChange={handleChange}
          required
          isInvalid={validated && !address.postcode}
          placeholder="Postcode" 
        />
        <Form.Control.Feedback type="invalid">
          Please enter postcode.
        </Form.Control.Feedback>
      </Form.Group>

               {/* <Form.Control 
                            id="lat" 
                            value={address.lat}                            
                            placeholder="lat" 
                            required 
                            readOnly
                        />
                        <Form.Control 
                            id="lng" 
                            value={address.lng}                            
                            placeholder="lng" 
                            required 
                            readOnly
                        /> */}

    </>
  );
};

export default AddressForm;
